<template>
  <div class>
    <div class="card css-table">
      <DataTable
        :value="warehouse_outbounds"
        :paginator="false"
        :loading="loading.filter"
        :rowHover="true"
        :selection.sync="selected_items"
      >
        <template #empty>Data tidak ditemukan.</template>
        <template #loading>Menggabil data daftar barang. Mohon tunggu</template>
        <h5>
          <b>Buat Bon Mutasi Harga</b>
        </h5>
        <template #header>
          <div class="table-header">
            <div class="p-col-12 p-md-6 p-lg-3">
              <AutoComplete
                placeholder="Pilih Toko"
                :dropdown="true"
                :multiple="false"
                v-model="outlet_selected"
                :suggestions="outlets"
                field="name"
                @complete="searchOutlets($event)"
                @input="onInputOutlet()"
              >
                <template #item="slotProps">
                  <div>{{ slotProps.item.name }}</div>
                  <div style="font-style: italic; font-size: 12px">
                    {{ slotProps.item.code }}
                  </div>
                </template>
              </AutoComplete>
            </div>
          </div>
        </template>

        <Column field="cat_no" header="No" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ warehouse_outbounds.indexOf(slotProps.data) + 1 }}
          </template>
        </Column>
        <Column header="Kode Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_code }} </span>
          </template>
        </Column>
        <Column header="Nama Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_name }} </span>
          </template>
        </Column>
        <Column header="Harga">
          <template #body="slotProps">
            <span>{{ slotProps.data.price | currency }}</span>
          </template>
        </Column>

        <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      </DataTable>

      <div
        class="p-grid p-justify-center p-mt-4"
        v-if="warehouse_outbounds.length != 0 && selected_items.length != 0"
      >
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            class="btn btn-primary"
            @click="generateBON()"
            style="width: 100%"
          >
            Buat BON
          </button>
        </div>
      </div>

      <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
        <Dialog
          :visible.sync="generate_dialog"
          :style="{ width: '450px' }"
          header="Generate BON"
          :modal="true"
          class="p-fluid"
        >
          <div class="confirmation-content">
            <i class="pi pi-print p-mr-3" style="font-size: 1rem" />
            <span> Tekan Ok untuk membuat Bon </span>
          </div>
          <template #footer>
            <button
              type="button"
              label="Cancel"
              icon="pi pi-times"
              class="btn btn-danger p-p-3"
              @click="generate_dialog = false"
            >
              Cancel
            </button>
            <button
              type="button"
              label="OK"
              icon="pi pi-check"
              class="btn btn-primary p-p-3"
              @click="postOutletInbounds()"
            >
              OK
              <span v-if="loading_bon">
                <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
              </span>
            </button>
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      generate_dialog: false,
      loading_bon: false,

      loading: {
        filter: false
      },

      outlets: [],
      outlet_filtered: [],
      outlet_selected: null,

      warehouse_outbounds: [],
      selected_items: [],

      warehouse_outbounds_id: [],
      status: ''
    }
  },
  mounted() {
    this.getMutationPriceList()
  },
  methods: {
    async getMutationPriceList() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/outlets?status=1`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching mutation price list:', error)
      }
    },

    async searchOutlets(event) {
      try {
        const searchQuery =
          this.outlet_selected instanceof Object
            ? this.outlet_selected.code
            : this.outlet_selected
            ? this.outlet_selected
            : ''

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/outlets`,
          {
            params: {
              status: 1,
              type: 'PRICE_MUTATION',
              search: searchQuery,
              limit: 5
            }
          }
        )

        if (response.status === 200) {
          this.outlets = response.data.data.outlets
          this.outlet_filtered = this.outlets.filter(item => {
            const lowerCaseQuery = event.query.toLowerCase()
            return (
              item.name.toLowerCase().startsWith(lowerCaseQuery) ||
              item.code.toLowerCase().startsWith(lowerCaseQuery)
            )
          })
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      }
    },

    onInputOutlet() {
      if (this.outlet_selected.id) {
        this.getWarehouseOutbounds()
      }
    },

    async getWarehouseOutbounds() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds?outlet_id=${this.outlet_selected.id}&status=1&type=PRICE_MUTATION`
        )
        if (response.status === 200) {
          this.warehouse_outbounds = response.data.data.warehouse_outbound
        }
      } catch (error) {
        console.error('Error fetching warehouse outbounds:', error)
      }
    },

    generateBON() {
      this.generate_dialog = true
      this.warehouse_outbounds_id = []

      for (var i = 0; i < this.selected_items.length; i++) {
        this.warehouse_outbounds_id.push(this.selected_items[i].id)
      }
    },

    async postOutletInbounds() {
      this.loading_bon = true
      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds/distribution`,
          { warehouse_outbounds_id: this.warehouse_outbounds_id }
        )

        if (response.status === 200) {
          this.generate_dialog = false

          this.$router.push({
            name: 'bon-detail',
            query: { doc_number: response.data.data.doc_number }
          })
        }
      } catch (error) {
        console.error('Error posting outlet inbounds:', error)
      } finally {
        this.loading_bon = false
        this.generate_dialog = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
